// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1Qkdb","Success":"Button_Success__ORMvn","Danger":"Button_Danger__2c7Kh"};